<template>
	<div v-show="show_option" class="option shadow-1  border-radius-1" v-on:click="showProjectDetails">
		<!-- <div ref="option_background" class="option-background"></div> -->
		<div class="type shadow-sm">{{projects_option.type}}</div>
		<div class="name">{{projects_option.name}}</div>
		<div v-html="projects_option.description" class="descriptions">{{truncated_description}}</div>
		<p class="services">
			<span class="services-heading">Services rendered:</span>
			<ul v-for="(service, index) in projects_option.services" :key="index" :index="index" >
				<li >{{service}}</li>
			</ul>
		</p>
		<img 
			alt="project image"
			v-if="main_image_exists" 
			class="main-image border-radius-1 shadow-2" 
			:src="main_image" 
			@error="main_image_exists = false" />
		<img 
			alt="project images"
			class="other-images border-radius-1 shadow-2"
			v-for="(image, index) in projects_option.images.others " 
			:key="index"
			:src="'/img/jpg/projects'+image" />
	</div>
</template>

<script>
export default {
	components: {
	},
	props: {
		projects_option: {
			type: Object,
			required: true
		},
		index: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			main_image_exists: true,
			main_image_loaded: false,
			main_image: '/img/jpg/projects' + this.projects_option.images.main,
			show_option: false,
			project_id: null,
			truncated_description: ''
		};
	},
	created() {
		this.truncated_description = this.removeTags(this.projects_option.description);
		if(this.truncated_description.length > 200) {
			this.truncated_description = this.truncated_description.substring(0, 200) + '...';
		}
	},
	mounted() {
		setTimeout(() => {
			this.show_option = true;
			this.$nextTick(()=>{
				this.project_id = this.projects_option.id;
			});
		}, this.index*50);
	},
	methods: {
		showProjectDetails() {
			// this.$router.push({
			// 	query: {
			// 		pd: this.project_id
			// 	}
			// });
		},
		removeTags(_string) {
			return _string.replace(/<.*>/gi, ' ');
		}
	},
	watch: {
		projects_option(_old, _new) {
			this.project_id = _new.id;
		}
	}
};
</script>

<style lang="scss" scoped>
	@import '../assets/style/main.scss';
	.option {
		position: relative;
		overflow: hidden;
		z-index: 1;
		color: $white;
		background-color: $white-light-tr-3;

		float: left;
		margin-bottom: 1em;
		margin-right: 1em;
		max-width: 360px;
		
		@supports (position: sticky) {
			float: none !important;
			margin-bottom: unset !important;
			margin-right: unset !important;
			max-width: unset !important;
			min-height: unset !important;
			max-width: unset !important;
			display: flex;
			justify-content: flex-start;
		}
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		padding: 1em 1em;
		transition: all 150ms ease-in;
		animation: flip-in-up 500ms ease-in-out forwards;
		transform-style: none;
		&>div {
			flex-grow: 0;
			text-align: start;
		}


		>.main-image {
			transition: all 500ms ease-in-out;
			object-fit: cover;
			margin-left: 0%;
			width: 100%;
			align-self: center;
		}
		>.other-images {
			transition: all 500ms ease-in-out;
			margin-top: 1em;
			object-fit: cover;
			margin-left: 0%;
			width: 100%;
			align-self: center;
		}
		&>.type {
			align-self: center;
			font-size: 0.8em;
			z-index: 1;
			position: relative;
			color: rgba(238, 238, 238, 0.9);
			border-radius: 2em;
			background-color: $white-light-tr-3;
			padding: 0.2em 1em;
			margin-bottom: 1.5em;
		}

		&>.name {
			z-index: 1;
			text-align: start;
			width: 100%;
			font-weight: 500;
			letter-spacing: 0.1px;
			font-size: 1.1em;
			margin-bottom: 0.25em;
			border-bottom-color: $black-light-tr-3;
			border-bottom-style: solid;
			border-bottom-width: 1px;
			padding-bottom: 1em;
		}
		&>.descriptions {
			margin-top: 1em;
			margin-bottom: 1em;
			z-index: 1;
			letter-spacing: 0.1px;
			font-size: 15px;
		}

		>.services {
			text-align: start;
			>.services-heading {
				font-weight: 500;
				letter-spacing: 0.1px;
			}
			>ul {
				margin: 0px;
				li {
					letter-spacing: 0.1px;
				}
			}
		}
	}
</style>